import { createApp, h } from 'vue'
import { VueTelInput } from 'vue3-tel-input'
import FlatPickr from 'vue-flatpickr-component'
import 'vue3-tel-input/dist/vue3-tel-input.css'
import Pagination from './Components/Pagination'
import Modal from './Shared/Components/Modals/Modal'
import Error from './Shared/Components/Error'
import ContentSlot from './Pages/Member/Community/ContentSlot'
import BankAccountTemplate from './Pages/BankAccountTemplate'
import { InertiaProgress } from '@inertiajs/progress'
import { createInertiaApp, Link, Head } from '@inertiajs/inertia-vue3'
import VimeoIframe from './Components/VimeoIframe'
import LiveVideoIframe from './Components/LiveVideoIframe'
// import CKEditor from '@ckeditor/ckeditor5-vue'

require('./bootstrap');

const inertiaPage = document.querySelector('script[data-page="app"]')

createInertiaApp({
	page: inertiaPage ? JSON.parse(inertiaPage.textContent || '{}') : undefined,
	resolve: (name) => require(`./Pages/${name}`),
	setup({ el, App, props, plugin }) {
		createApp({ render: () => h(App, props) })
			.use(plugin)
			// .use(CKEditor)
			.mixin({ methods: { route } })
			.component('Modal', Modal)
			.component('Error', Error)
			.component('ContentSlot', ContentSlot)
			.component('BankAccountTemplate', BankAccountTemplate)
			.component('Pagination', Pagination)
			.component('VueTelInput', VueTelInput)
			.component('FlatPickr', FlatPickr)
			.component('VimeoIframe', VimeoIframe)
			.component('LiveVideoIframe', LiveVideoIframe)
			.component('InertiaLink', Link)
			.component('InertiaHead', Head)
			// .component('CKEditor', CKEditor.component)
			.provide("moneyFormatter",function(){
				return new Intl.NumberFormat('en-US', {
					  style: 'currency',
					  currency: 'PHP'
					});
			})
			.mount(el)

	},
	title: (title) => `${title} | TRC`
})

InertiaProgress.init({
	showSpinner: true,
	color: '#1e824c',
})

window.gtag_id = "G-M1QJBE08Y7";

window.ucWordsName = (name)=>{
	let nameA = name.split(' ');
  	let name1 = nameA[0][0].toUpperCase()+nameA[0].slice(1).toLowerCase();
  	let name2 = "";

  	if(nameA.length>1)
  	{
  		name2 = " "+nameA[1][0].toUpperCase() + nameA[1].slice(1).toLowerCase();
  	}

  return name1 + name2;
}
